import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { db } from '../../firebaseFunctions/authhook';
import Close from '../Close/Close';
import Home from '../Home/Home';

const HomeControll: React.FC = () => {
    const usersCollectionRef = collection(db, "appointment_lists");
    const timeSchedulingRef = collection(db, "timeScheduling");
    const seatCollectionRef = collection(db, "seatAvailablePerDay");

    const d = new Date();
    let currentTime = d.getHours() * 3600 + d.getMinutes() * 60;

    const [appointmentList, setAppointmentList] = useState<[] | any>([]);
    const [timesData, setTimesData] = useState<object | any>({
        openingTime: '',
        closingTime: ''
    });
    const [seatdata, setSeatData] = useState<number | any>([])
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        setIsLoading(true)
       const getData = async () => {
        const userCollection = query(usersCollectionRef, where('date', "==", new Date().toDateString()));
        const userData = await getDocs(userCollection);
        const userdat = userData.docs.map((doc) => doc.data());
        setAppointmentList(userdat);
       }
       getData();
       const t = query(timeSchedulingRef);
        onSnapshot(t, (snapshot) => {
            const times = snapshot.docs.map((doc) =>doc.data());
            setTimesData(times[0])
        });
       const s = query(seatCollectionRef)
       onSnapshot(s, (snapshot) => {
           const seat = snapshot.docs.map((doc) => doc.data());
           setSeatData(seat[0].totalNumberOfSeat)
       })
       setIsLoading(false)
    }, []);
    const open = timesData.openingTime.split(':');
    const close = timesData.closingTime.split(':');
    const openTimeInSeconds = parseFloat(open[0]) * 3600 + parseFloat(open[1]) * 60;
    const closingTimeInSeconds = parseFloat(close[0]) > 0 && parseFloat(close[1]) > 0 ? (parseFloat(close[0]) * 3600 + parseFloat(close[1]) * 60) : 86400;

    if (isLoading) {
        return <ClipLoader loading={true} size={50} />
    }
    if (currentTime > openTimeInSeconds && currentTime < closingTimeInSeconds && appointmentList.length < parseInt(seatdata)){
        return <Home />
    }

    return <Close />

};

export default HomeControll;
